import React from 'react';
import { ToggleButton, ToggleButtonGroup, styled } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  padding: '3px',
  backgroundColor: '#fff',
  borderRadius: '30px',
  position: 'relative',
  display: 'inline-flex',
  width: 'fit-content',
  border: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    padding: '1px',
    background: saasModernTheme.customColor.gradiantColor,
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },

  '& .MuiToggleButtonGroup-grouped': {
    margin: '0 2px',
    border: 0,
    '&:not(:first-of-type)': {
      borderRadius: '25px',
    },
    '&:first-of-type': {
      borderRadius: '25px',
    },
    '&.Mui-disabled': {
      border: 0,
    },
  },
})); 

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '25px',
  padding: '8px 20px',
  minWidth: '80px',
  color: '#636F81',
  fontSize: '16px',
  fontWeight: 600,

  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },

  '&.Mui-selected': {
    backgroundColor: 'rgba(25, 118, 210, 0.05)',
    fontWeight: '600',
    position: 'relative',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      padding: '1px',
      background:
        saasModernTheme.customColor.gradiantColor ||
        'linear-gradient(90deg, #2196f3, #ff9800)',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
    },
  },
}));

const STGradiantToggle = ({ toggleData, value, onChange, ...rest }) => {
  
  return (
    <StyledToggleButtonGroup
      value={value}
      onChange={onChange}
      exclusive
      aria-label="navigation toggle"
      {...rest}
    >
      {toggleData.map((toggle) => (
        <StyledToggleButton key={toggle.value} value={toggle.value}>
          {toggle.label}
        </StyledToggleButton>
      ))}
    </StyledToggleButtonGroup>
  );
};

export default STGradiantToggle;
